import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id"];
var _hoisted_2 = ["aria-expanded", "aria-controls"];
import { ArrowIcon } from "@vueEntry/SvgIcons/ArrowIcon";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'BaseAccordionBtn',
  props: {
    id: {},
    arrowWidth: {
      "default": 12
    },
    onContainerClickExpand: {
      type: Boolean,
      "default": false
    },
    accordionOpen: {
      type: Boolean,
      "default": false
    },
    toggleAccordion: {}
  },
  emits: ["click"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        id: _ctx.id,
        "class": _normalizeClass(["tw-flex tw-items-center tw-justify-around", [_ctx.$attrs['btn-wrapper-classes'], _ctx.onContainerClickExpand && 'tw-cursor-pointer']]),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.onContainerClickExpand && _ctx.toggleAccordion();
        })
      }, [_renderSlot(_ctx.$slots, "custom_content"), _renderSlot(_ctx.$slots, "custom_btn", {
        btnId: "btn-".concat(_ctx.id),
        isOpen: _ctx.accordionOpen,
        toggleAccordion: _ctx.toggleAccordion
      }, function () {
        return [_createElementVNode("button", {
          type: "button",
          "class": _normalizeClass(["tw-bg-transparent", _ctx.$attrs['btn-classes']]),
          "aria-expanded": _ctx.accordionOpen,
          "aria-controls": "accordion-text-".concat(_ctx.id),
          onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
            _ctx.toggleAccordion();
            emits('click');
          }, ["prevent", "stop"]))
        }, [_createVNode(_unref(ArrowIcon), {
          "class": _normalizeClass(["tw-transition-transform motion-reduce:tw-transition-none", [_ctx.accordionOpen && '-tw-rotate-180', _ctx.$attrs['arrow-classes']]]),
          width: _ctx.arrowWidth,
          height: _ctx.arrowWidth
        }, null, 8 /* PROPS */, ["class", "width", "height"])], 10 /* CLASS, PROPS */, _hoisted_2)];
      })], 10 /* CLASS, PROPS */, _hoisted_1);
    };
  }
}));